// extracted by mini-css-extract-plugin
module.exports = {"cover":"apiLicenseAgreement_cover__1Pk4_","title":"apiLicenseAgreement_title__2lIBv"};